import Vue from 'vue'
import VueRouter from 'vue-router'
import AppPageHome from '@/components/app-page-home'
import AppPageMenu from '@/components/app-page-menu'
import AppPageSlider from '@/components/app-page-slider'
import AppPageContent from '@/components/app-page-content'
import AppPage404 from '@/components/app-page-404'

import config from '@/config.js'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: '/experience/innovation/',
    routes:
    [
        {
            path: '/:lang/',
            name: 'home',
            component: AppPageHome,
            meta:
            {
                soundAmbient: 'default',
                experienceCameraScrollDestination: null,
                experienceRgbOffset: 'intro',
                sliderIndex: 0
            }
        },
        {
            path: '/:lang/menu',
            name: 'menu',
            component: AppPageMenu,
            meta:
            {
                soundAmbient: 'default',
                experienceCameraScrollDestination: null,
                experienceRgbOffset: 'intro'
            }
        },
        {
            path: '/:lang/slider',
            name: 'slider',
            component: AppPageSlider,
            meta:
            {
                soundAmbient: 'default',
                experienceCameraScrollDestination: null,
                experienceRgbOffset: 'intro'
            }
        },
        {
            path: '/:lang/protect',
            name: 'protect',
            component: AppPageContent,
            meta:
            {
                slug: 'protect',
                soundAmbient: 'under',
                experienceCameraScrollDestination: 'protectExperience',
                experienceFocusScene: 'protect',
                experienceKeypointScene: 'protect',
                experienceRgbOffset: 'protect',
                experienceInteraction: 'barrels',
                sliderIndex: 0
            }
        },
        {
            path: '/:lang/validate',
            name: 'validate',
            component: AppPageContent,
            meta:
            {
                slug: 'validate',
                soundAmbient: 'under',
                experienceCameraScrollDestination: 'validateExperience',
                experienceFocusScene: 'validate',
                experienceKeypointScene: 'validate',
                experienceRgbOffset: 'validate',
                experienceInteraction: 'tank',
                sliderIndex: 1
            }
        },
        {
            path: '/:lang/training',
            name: 'training',
            component: AppPageContent,
            meta:
            {
                slug: 'training',
                soundAmbient: 'under',
                experienceCameraScrollDestination: 'trainingExperience',
                experienceFocusScene: 'training',
                experienceKeypointScene: 'training',
                experienceRgbOffset: 'training',
                experienceInteraction: 'simulation',
                sliderIndex: 2
            }
        },
        {
            path: '/:lang/investigate',
            name: 'investigate',
            component: AppPageContent,
            meta:
            {
                slug: 'investigate',
                soundAmbient: 'under',
                experienceCameraScrollDestination: 'investigateExperience',
                experienceFocusScene: 'investigate',
                experienceKeypointScene: 'investigate',
                experienceRgbOffset: 'investigate',
                experienceInteraction: 'droning',
                sliderIndex: 3
            }
        },
        {
            path: '/:lang/*',
            name: '404',
            component: AppPage404,
            meta:
            {
                soundAmbient: 'default',
                experienceCameraScrollDestination: null
            }
        }
    ]
})

router.afterEach(() =>
{
    // Tag
    if(window.tag)
    {
        window.tag.page.set({})
        window.tag.dispatch()
    }
})

router.beforeEach((to, from, next) =>
{
    // No lang found
    if(typeof to.params.lang === 'undefined')
    {
        const navigatorLang = navigator.language || navigator.userLanguage

        // Navigator lang exist
        if(config.langs.all.find((_lang) => _lang === navigatorLang))
        {
            next({ name: config.langs.default.name, params: { ...config.langs.default.params, lang: navigatorLang } })
        }

        // Navigator lang doesn't exist
        else
        {
            next({ name: config.langs.default.name, params: config.langs.default.params })
        }
    }

    // Lang found
    else
    {
        // Lang doesn't exist
        if(!config.langs.all.find((_lang) => _lang === to.params.lang))
        {
            const navigatorLang = navigator.language || navigator.userLanguage

            // Navigator lang exist
            if(config.langs.all.find((_lang) => _lang === navigatorLang))
            {
                next({ name: config.langs.default.name, params: { ...config.langs.default.params, lang: navigatorLang } })
            }

            // Navigator lang doesn't exist
            else
            {
                next({ name: config.langs.default.name, params: config.langs.default.params })
            }
        }

        // Lang exist
        else
        {
            next()
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js